import React from "react";
import "./tagField.css";

// Simple tags input replacement
const TagsInput = ({
  value = [],
  onChange,
  placeholder,
  className,
  ...props
}) => {
  const [inputValue, setInputValue] = React.useState("");

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && e.target.value.trim()) {
      e.preventDefault();
      onChange([...value, e.target.value.trim()]);
      setInputValue("");
    }
  };

  const handleBlur = (e) => {
    if (e.target.value.trim()) {
      onChange([...value, e.target.value.trim()]);
      setInputValue("");
    }
  };

  const removeTag = (index) => {
    onChange(value.filter((_, idx) => idx !== index));
  };

  return (
    <div className={className}>
      {value.map((tag, i) => (
        <span key={i} className="react-tagsinput-tag">
          {tag}
          <button
            type="button"
            className="react-tagsinput-remove"
            onClick={() => removeTag(i)}
          >
            ×
          </button>
        </span>
      ))}
      <input
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        placeholder={placeholder}
        className="react-tagsinput-input"
        {...props}
      />
    </div>
  );
};

const TagField = (props) => {
  const { value, onChange, label, placeholder } = props;
  return (
    <div style={{ width: "100%", marginBottom: 8 }}>
      <label className="block__form_element_label">{label}</label>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <TagsInput
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className="body_field tags-input react-tagsinput"
        />
      </div>
    </div>
  );
};

export default TagField;
